import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { searchWord } from "../../_helpers/search";
import { useProduct } from "../../../services/products/product.context";
import { formatImageUrl } from "../../_helpers/route-image";



export const SearchForm = ({ onClose }) => {

    const [isTyping, setIsTyping] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [inventory, setInventory] = useState([]);

    const { getProductsByBatch } = useProduct();

    const navigateTo = useNavigate();

    // const itemList = () => {
    //     const productNames = inventory.map((product) => product?.designation);
    //     const productBrands = inventory.map((product) => product.brand);

    //     const res = [...productBrands, ...productNames];

    //     return [...new Set(res)];
    // }

    const handleInput = (v) => {
        setIsTyping(true);
        //const wordList = itemList();
        const searchRes = searchWord(v, inventory);
        setSearchResult(searchRes);
         (async() => {
            const resp = await getProductsByBatch();
            setInventory(resp?.data);
        })();
    }

    return (
        <div className="search-flap">
            <button className="tr-btn" onClick={onClose}>
                 <FontAwesomeIcon className="s-icon" icon={faClose} />
            </button>
            <form
                className="search-form"
                onSubmit={(e) => {
                    e.preventDefault();
                }}
            >
                <FontAwesomeIcon className="s-icon" icon={faSearch} />
                {searchResult.length > 0 && <span className="s-txt">Search </span>}
                <input
                    type="search"
                    name="keyword"
                    className="search-input"
                    onChange={(e) => handleInput(e.target.value)}
                    onBlur={() => setIsTyping(false)}
                    placeholder="Search Brand/Category/device"
                />

            </form>
            {searchResult.length > 0 && (
                <div className="search-result">
                    {searchResult.map((result, i) => (
                        <button
                            key={i}
                            className="search-touch"
                            onClick={() => navigateTo("/details", { state: result })}
                        >
                            <img 
                                src={formatImageUrl(result?.images[0])}
                                className="search-img" 
                            />
                            <span>{result?.designation}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}